export const EXCMTEAMUSERDATA_DELETE_RESET = 'EXCMTEAMUSERDATA_DELETE_RESET'
export const EXCMTEAMUSERDATA_DELETE_SET_ERROR = 'EXCMTEAMUSERDATA_DELETE_SET_ERROR'
export const EXCMTEAMUSERDATA_DELETE_SET_DELETED = 'EXCMTEAMUSERDATA_DELETE_SET_DELETED'
export const EXCMTEAMUSERDATA_DELETE_TOGGLE_LOADING = 'EXCMTEAMUSERDATA_DELETE_TOGGLE_LOADING'
